import * as React from 'react'
import { Menu, Button } from 'semantic-ui-react'
import { RootStoreContext } from '../../../model/root-store'
import styles from './CurrentOrder.module.scss'
import { ModalPayment } from './ModalPayment'
import { handleAgentErrorResponse } from '../../../libs/error-handler'
import { toast } from 'react-toastify'
import { FormattedCurrency } from '../../../components/FormattedCurrency'
import {
  checkAndGetValidGiftValentine,
  checkAndGetValidGift8T3,
  checkAndGetValidGiftWomen20t10,
  checkAndGetValidFatherDayGift,
  checkAndGetValidMooncakeGiftBox,
  checkCutleryGiftEligibility,
  checkAndGetValidTeacherDayGift
} from '../../../libs/bulk-discount'
import { observer } from 'mobx-react-lite'

export const CurrentOrderActions = observer(function CurrentOrderActions() {
  const rootStore = React.useContext(RootStoreContext)
  const orderStore = rootStore.orderStore
  const { canUseCurrentOutlet } = rootStore.authenticationStore
  const loggedInShift = rootStore.currentShiftStore.loggedInShift

  // const deliverDeadline =
  //   orderStore.onlineOrder && orderStore.onlineOrder.deadline
  //     ? new Date(orderStore.onlineOrder.deadline)
  //     : new Date()

  async function handleSendOrder() {
    try {
      await orderStore.sendOrder()
    } catch (e) {
      handleAgentErrorResponse(e)
      return
    }

    toast.success('Đã tạo Order')
  }

  async function handleCreateAndDoneOrder() {
    try {
      await orderStore.createAndDoneOrder()
    } catch (e) {
      handleAgentErrorResponse(e)
      return
    }
  }

  const buttons = loggedInShift
    ? [
        <Button
          key="done"
          positive
          color="green"
          onClick={handleCreateAndDoneOrder}
          disabled={orderStore.saving}
        >
          Done
        </Button>
      ]
    : canUseCurrentOutlet
      ? [
          <Button positive key="save" onClick={handleSendOrder} disabled={orderStore.saving}>
            Lưu Order
          </Button>
        ]
      : []

  // let alertMessages: string[] = ['- 1 x V8777 Sing-gum sampling doublemint']
  let alertMessages: string[] = []

  // const outlet = rootStore.currentShiftStore.currentShift
  //   ? rootStore.currentShiftStore.currentShift.outlet
  //   : null

  if (
    checkAndGetValidFatherDayGift(
      orderStore.items,
      orderStore.onlineOrder,
      orderStore.getOutletCode()
    ).isValid
  ) {
    const giftData = checkAndGetValidFatherDayGift(
      orderStore.items,
      orderStore.onlineOrder,
      orderStore.getOutletCode()
    )
    alertMessages.push(`- ${giftData.giftNum} x ${giftData.giftText}`)
  }

  // Valentine
  if (checkAndGetValidGiftValentine(orderStore.items, orderStore.onlineOrder, 'mica').isValid) {
    const giftData = checkAndGetValidGiftValentine(orderStore.items, orderStore.onlineOrder, 'mica')

    alertMessages.push(`- ${giftData.giftNum} x ${giftData.giftText}`)
  }
  if (checkAndGetValidGiftValentine(orderStore.items, orderStore.onlineOrder, 'card').isValid) {
    const giftData = checkAndGetValidGiftValentine(orderStore.items, orderStore.onlineOrder, 'card')

    alertMessages.push(`- ${giftData.giftNum} x ${giftData.giftText}`)
  }
  // 8/3
  if (checkAndGetValidGift8T3(orderStore.items, orderStore.onlineOrder, 'card').isValid) {
    const giftData = checkAndGetValidGift8T3(orderStore.items, orderStore.onlineOrder, 'card')

    alertMessages.push(`- ${giftData.giftNum} x ${giftData.giftText}`)
  }
  if (checkAndGetValidGift8T3(orderStore.items, orderStore.onlineOrder, 'sparkle').isValid) {
    const giftData = checkAndGetValidGift8T3(orderStore.items, orderStore.onlineOrder, 'sparkle')

    alertMessages.push(`- ${giftData.giftNum} x ${giftData.giftText}`)
  }

  // 20/10
  if (checkAndGetValidGiftWomen20t10(orderStore.items, orderStore.onlineOrder, 'card').isValid) {
    const giftData = checkAndGetValidGiftWomen20t10(
      orderStore.items,
      orderStore.onlineOrder,
      'card'
    )

    alertMessages.push(`- ${giftData.giftNum} x ${giftData.giftText}`)
  }

  if (checkAndGetValidGiftWomen20t10(orderStore.items, orderStore.onlineOrder, 'sparkle').isValid) {
    const giftData = checkAndGetValidGiftWomen20t10(
      orderStore.items,
      orderStore.onlineOrder,
      'sparkle'
    )

    alertMessages.push(`- ${giftData.giftNum} x ${giftData.giftText}`)
  }

  // Bánh trung thu - tặng hộp con
  const mooncakeGiftBoxData = checkAndGetValidMooncakeGiftBox(orderStore.items)
  if (mooncakeGiftBoxData.isValid) {
    alertMessages.push(
      `- ${mooncakeGiftBoxData.giftQuantity} x Hộp con bánh trung thu (B7310 hoặc B7309)`
    )
  }

  // Chương trình tặng Bộ dao dĩa cao cấp
  const cutleryGiftEligibility = checkCutleryGiftEligibility({
    customer: orderStore.computedCustomer,
    orderPlatform: orderStore.orderPlatform,
    items: orderStore.items,
    orderType: orderStore.orderType,
    saleTotal: orderStore.saleTotal
  })
  if (cutleryGiftEligibility.isEligible) {
    alertMessages.push(
      `- ${cutleryGiftEligibility.maxQuantity} x ${cutleryGiftEligibility.giftSku} ${cutleryGiftEligibility.giftText}`
    )
  }

  // 20/11
  if (checkAndGetValidTeacherDayGift(orderStore.items, orderStore.onlineOrder).isValid) {
    const teacherDayGiftConfig = checkAndGetValidTeacherDayGift(
      orderStore.items,
      orderStore.onlineOrder
    )
    alertMessages.push(`- ${teacherDayGiftConfig.giftQuantity} x ${teacherDayGiftConfig.giftText}`)
  }

  return orderStore.computedItems.length > 0 ? (
    <Menu attached="bottom" className={styles['actions']}>
      {alertMessages.length > 0 ? (
        <div className={styles['actions__alert']}>
          <div className={styles['actions__alert-text']}>
            <strong>Đơn hàng (tạm tính) được tặng:</strong>
            <br />
            {alertMessages.map((item, index) => {
              return (
                <p key={index} style={{ margin: 0 }}>
                  {item}
                </p>
              )
            })}
          </div>
        </div>
      ) : null}
      <Menu.Item
        as={() => (
          <ModalPayment buttonActions={buttons} orderStore={orderStore}>
            <Button color="green" fluid style={{ marginRight: 0 }}>
              Nhận <FormattedCurrency value={orderStore.cashTotal} />
            </Button>
          </ModalPayment>
        )}
      />
    </Menu>
  ) : null
})
